import {useEffect, useState} from "react";
import {RequestState} from "../../../../Shared/StateHelper";
import axios from "axios";

const useMedicalEvents = ({ filter = "", showAll = false, page = 1, enabled = true } = {}) => {
    const [medicalEvents, setMedicalEvents] = useState([])
    const [state, setState] = useState(RequestState.LOADING)

    useEffect(() => {
        if (!enabled) return

        setState(RequestState.LOADING)

        axios.get("/admin/console/medical_events/", {
            params: {
                filter,
                showAll,
                page
            }
        }).then(response => {
            setMedicalEvents(response.data)
            setState(RequestState.SUCCESS)
        }).catch(() => {
            setState(RequestState.ERROR)
        });
    }, [filter, showAll, page, enabled])

    const get = (id) => {
        setState(RequestState.LOADING)
        return axios.get(`/admin/console/medical_events/${id}`).then(resp => {
            setState(RequestState.SUCCESS)
            return resp
        }).catch(() => {
            setState(RequestState.ERROR)
        })
    }

    const create = (medicalEvent) => {
        return axios.post("/admin/console/medical_events", medicalEvent)
    }

    const update = (medicalEvent) => {
        return axios.patch(`/admin/console/medical_events/${medicalEvent.id}`, medicalEvent)
    }

    return { medicalEvents, get, create, update, state }
}

export default useMedicalEvents;